import { gql } from '@apollo/client';
import { APPROVAL_FIELDS_FRAGMENT } from './fragments';

/**
 * Create new approval request
 */
export const CREATE_APPROVAL = gql`
  ${APPROVAL_FIELDS_FRAGMENT}
  mutation CreateApproval($tenantId: String!, $input: CreateApprovalInput!) {
    createApproval(tenantId: $tenantId, input: $input) {
      ...ApprovalFields
    }
  }
`;

/**
 * Record approval decision
 */
export const RECORD_APPROVAL_DECISION = gql`
  ${APPROVAL_FIELDS_FRAGMENT}
  mutation RecordApprovalDecision($input: RecordApprovalDecisionInput!) {
    recordApprovalDecision(input: $input) {
      ...ApprovalFields
    }
  }
`;

/**
 * Escalate approval to another actor
 */
export const ESCALATE_APPROVAL = gql`
  ${APPROVAL_FIELDS_FRAGMENT}
  mutation EscalateApproval($input: EscalateApprovalInput!) {
    escalateApproval(input: $input) {
      ...ApprovalFields
    }
  }
`;

/**
 * Delegate approval to another actor
 */
export const DELEGATE_APPROVAL = gql`
  ${APPROVAL_FIELDS_FRAGMENT}
  mutation DelegateApproval(
    $tenantId: String!
    $approvalId: String!
    $delegateToActorId: String!
  ) {
    delegateApproval(
      tenantId: $tenantId
      approvalId: $approvalId
      delegateToActorId: $delegateToActorId
    ) {
      ...ApprovalFields
    }
  }
`;

/**
 * Add comment to approval
 */
export const ADD_APPROVAL_COMMENT = gql`
  ${APPROVAL_FIELDS_FRAGMENT}
  mutation AddApprovalComment($input: AddApprovalCommentInput!) {
    addApprovalComment(input: $input) {
      ...ApprovalFields
    }
  }
`;

/**
 * Update approval priority
 */
export const UPDATE_APPROVAL_PRIORITY = gql`
  ${APPROVAL_FIELDS_FRAGMENT}
  mutation UpdateApprovalPriority(
    $tenantId: String!
    $approvalId: String!
    $priority: ApprovalPriority!
  ) {
    updateApprovalPriority(tenantId: $tenantId, approvalId: $approvalId, priority: $priority) {
      ...ApprovalFields
    }
  }
`;
